import { ReducerAction, ReducerState } from 'common/types/reducers';

export const setOtherPermissions = (state: ReducerState, action: ReducerAction<{ otherPermissions: unknown }>) => ({
  ...state,
  ...action,
});
